import React, { useContext } from 'react';
import { LanguageContext } from '../LanguageContext';
import { HospitalityIcon } from '../icons/HospitalityIcon';
import { ResidentialIcon } from '../icons/ResidentialIcon';
import { OfficeIcon } from '../icons/OfficeIcon';
import { RetailIcon } from '../icons/RetailIcon';
import { EventsIcon } from '../icons/EventsIcon';
import { RealEstateIcon } from '../icons/RealEstateIcon';

const iconMap: { [key: string]: React.FC<{ className?: string }> } = {
    hospitality: HospitalityIcon,
    residential: ResidentialIcon,
    offices: OfficeIcon,
    retail: RetailIcon,
    events: EventsIcon,
    realestate: RealEstateIcon,
};


const Markets: React.FC = () => {
    const { t } = useContext(LanguageContext);
    const marketsData = t?.markets?.marketTiles || [];

    return (
        <section id="markets" className="py-20 sm:py-32 bg-white dark:bg-black scroll-mt-20">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center">
                    <h2 className="text-3xl font-bold tracking-tight sm:text-4xl text-gray-900 dark:text-gray-50">{t?.markets?.title || ''}</h2>
                    <p className="mt-4 text-lg text-gray-600 dark:text-gray-400 max-w-3xl mx-auto">{t?.markets?.description || ''}</p>
                </div>

                <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {marketsData.map((market: any, index: number) => {
                        const IconComponent = market.id ? iconMap[market.id] : null;
                        return (
                            <div key={market.id || index} className="bg-gray-50 dark:bg-gray-900/50 p-10 rounded-lg flex flex-col">
                                <div className="flex-shrink-0">
                                    {IconComponent && <IconComponent className="h-10 w-10 text-accent mb-4" />}
                                    <h3 className="text-xl font-bold text-gray-900 dark:text-gray-50">{market.label || ''}</h3>
                                    <p className="mt-2 text-gray-600 dark:text-gray-400 flex-grow">{market.description || ''}</p>
                                </div>
                                <div className="mt-6 border-t border-gray-200 dark:border-gray-800 pt-6">
                                    <p className="text-sm text-gray-600 dark:text-gray-400"><span className="font-semibold text-gray-700 dark:text-gray-300">Examples:</span> {market.examples || ''}</p>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default Markets;